import { render, staticRenderFns } from "./headTopserve.vue?vue&type=template&id=2c3dd38c&scoped=true&"
import script from "./headTopserve.vue?vue&type=script&lang=js&"
export * from "./headTopserve.vue?vue&type=script&lang=js&"
import style0 from "./headTopserve.vue?vue&type=style&index=0&id=2c3dd38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3dd38c",
  null
  
)

export default component.exports